<template>
	<div class="investor">
		<Header />
		<div class="content" style="width:100%;height:100vh">
			<Banner :src="src"/>
			<!-- produvct_banner -->
			<div style="width:70%;margin:0 auto">
				<div class="wrap_tab_nav"> 
                    <div class="wrap_tab"> 
                        <div class="container tab_nav clearfix"> 
                            <ul id="tab_nav"> 
                                <li style="font-size:18px;font-weight:bold;border-right:1px solid #9f9f9f;line-height:18px;height:18px;padding-right:40px;margin-top:20px;">关于我们</li>
                                <li class="current"> <a href="#about_anchor_introduce">{{titleOne}}</a> </li> 
                                <li> <a href="#about_anchor_dees">{{titleTwo}}</a> </li> 
                                <li> <a href="#about_anchor_join">{{titleThree}}</a> </li>
                                <li> <a href="#about_anchor_director">{{titleFour}}</a> </li> 
                                <!-- <li> <a href="#about_anchor_directorOne">业绩报告</a> </li>  -->
                            </ul> 
                        </div> 
                    </div> 
			    </div> 
			<!--  导航内容 --> 
			<div class="wrap_tab_content"> 
			  <!--  公司简介 --> 
				<div class="anchor_item pc_anchor_item mobile_anchor_item anchor_introduce" id="about_anchor_introduce"> 
					<div class="tab_con tab_con_introduce"> 
					    <h3 class="font-32 font-weight" style="margin-top:50px;margin-bottom:40px">{{titleOne}}</h3> 
                        <div v-html="investor_text"></div>
					</div> 
				</div>
        <!--  发展历程 --> 
				<div class="anchor_item pc_anchor_item mobile_anchor_item anchor_introduce" id="about_anchor_dees"> 
					<div class="tab_con tab_con_introduce"> 
					    <h3 class="font-32 font-weight" style="margin-top:50px;margin-bottom:40px">{{titleTwo}}</h3> 
              <div class="pro_c_item1">
								<ul>
									<li v-for="item in investor_list" :key="item.id">
										<img :src="item.src" alt="" style="width:100%">
									</li>
								</ul>
							</div>
					</div> 
				</div> 
        <!-- 企业文化 --> 
				<div class="anchor_item pc_anchor_item mobile_anchor_item anchor_join" id="about_anchor_join"> 
					<!-- <img src="../include/images/join.png" alt=""> --> 
					<div class="tab_con tab_con_bg"> 
						<h3 class="font-32 join_title font-weight" style="margin-top:50px;margin-bottom:40px">{{titleThree}}</h3> 
            <div v-html="valuetext" style="margin:0 auto;width:100%"></div>
					</div> 
					
				</div> 
        <!--  质量方针 --> 
				<div class="anchor_item pc_anchor_item mobile_anchor_item anchor_introduce" id="about_anchor_director"> 
					<div class="tab_con tab_con_introduce" style="padding-bottom:80px"> 
					    <h3 class="font-32 font-weight" style="margin-top:50px;margin-bottom:40px">{{titleFour}}</h3> 
                <div v-html="quality" style="width:100%;margin:0 auto"></div>
					</div> 
				</div>
			
				<!-- product_center -->
			</div>
			</div>
			
			<Footer />
		</div>
	</div>
</template>

<script>
const Base64=require('js-base64')
import Footer from '../../components/Footer.vue'
import Banner from '../../components/Banner.vue'
import Header from '../../components/Header.vue'
import Axios from "axios"
export default {
	components: { Header, Banner, Footer },
	data() {
		return {
			investor_detail:false,
			markers:[
				{position:[116.30327068220902, 40.04624763959285]}
			],
			center:[116.30327068220902, 40.04624763959285],
			zoom:16,
			src:'',
			investorDec:'',
			showjobDetail:false,
			activeName: 'first',
			tabName: '1',
			investor_business: false,
			showJoblist:true,
			investor_text:'',
			tabindex:'1',
      titleOne:'',
      titleTwo:'',
      titleThree:'',
      titleFour:'',
			contect:'',
			contect1:'',
			contect2:'',
			contect3:'',
			dec:'',
			notinvestor_business:true,
			// 业绩报告
			investor_business_list: [],
			investor_list: [{src:''}],
			email:'',
			erweima:'',
			phone:'',
			join: [],
			quality:'',
			joinPic:'',
			valuetext:'',
			p_data: [
				{
					id: 1,
					name: '名称',
					img_url: 'http://www.37digit.com/static/img/banner_1.c18a137.png',
				},
				{
					id: 2,
					name: '名称',
					img_url: 'http://www.37digit.com/static/img/banner_1.c18a137.png',
				},
				{
					id: 3,
					name: '名称',
					img_url: 'http://www.37digit.com/static/img/banner_1.c18a137.png',
				},
			],
			joblist:[],
		}
	},
	mounted(){
		const myTab = this.$route.query.myTab;
		if(!myTab){
			this.tabName='1'
		}else{
			this.handleSelect(myTab)
			this.tabindex=myTab
		}
     Axios({
			url: '/apiv2/sconfig/getlist',
			data: {},
			method: 'GET',
		}).then((res) => {
      let common=res.data.data.rows;
				for(var i=0;i<common.length;i++){
					
					if(common[i].sc_key.slice(0,16)=="INTRODUCE_BANNER"){
						this.src=common[i].sc_value
					}
					if(common[i].sc_key.slice(0,17)=='COMPANY_INTRODUCE'){
						this.investor_text=Base64.decode(common[i].sc_value).replaceAll("<a","<a rel='noopener noreferrer'")
					}
					if(common[i].sc_key.slice(0,7)=='JOIN_US'){
						this.join=Base64.decode(common[i].sc_value)
					}
          	if(common[i].sc_key.slice(0,11)=='ABOUTINTROU'){
						this.titleOne=common[i].sc_value
					}
          if(common[i].sc_key.slice(0,12)=='ABOUTPRODUCT'){
						this.titleTwo=common[i].sc_value
					}
          if(common[i].sc_key.slice(0,12)=='ABOUTCULTURE'){
						this.titleThree=common[i].sc_value
					}
          if(common[i].sc_key.slice(0,10)=='ABOUTGUIDE'){
						this.titleFour=common[i].sc_value
					}
					if(common[i].sc_key.slice(0,7)=='CONTACT'){
						this.contect=common[i].sc_value
						const length=this.contect.split('').length
						this.contect1=this.contect.slice(0,6)
						this.contect2=this.contect.slice(6,13)
						this.contect3=this.contect.slice(13,length)
					}
					if(common[i].sc_key.slice(0,5)=='EMAIL'){
						this.email=common[i].sc_value
					}
					if(common[i].sc_key.slice(0,5)=='PHONE'){
						this.phone=common[i].sc_value
					}
					if(common[i].sc_key.slice(0,6)=='QRCODE'){
						this.erweima=common[i].sc_value
					}
					if(common[i].sc_key.slice(0,5)=='ZHILI'){
						const src=common[i].sc_value
						this.investor_list[0].src=src
						
					}
					if(common[i].sc_key.slice(0,7)=='QUALITY'){
						this.quality=Base64.decode(common[i].sc_value).replaceAll("<a","<a rel='noopener noreferrer'")
					}
					 if(common[i].sc_key.slice(0,9)=="VALUETEXT"){
						this.valuetext=Base64.decode(common[i].sc_value).replaceAll("<a","<a rel='noopener noreferrer'")
					}
				}
    })
    
			Axios({
				url:'/apiv2/bdoc/getlist?bdContenttype=业绩报告',
				data:{},
				method:'GET',
			}).then((res)=>{
				for(var j=0;j<res.data.data.rows.length;j++){
					this.investor_business_list.push(res.data.data.rows[j])
				}
			})
			Axios({
				url:'/apiv2/bdoc/getlist?bdContenttype=加入我们',
				data:{},
				method:'GET',
			}).then((res)=>{
					this.joblist=res.data.data.rows
			})			
	},
	methods: {
		handleSelect(key) {
			this.tabName = key
		},
		handleClick(tab, event) {
			if (tab.index === '3') {
				this.investor_business = false
				this.notinvestor_business=true
				this.$router.push('/investor')
			}
		},
	},
  destroyed() {
	localStorage.setItem('toId','');
}
}
</script>

<style lang="scss" scoped>
.wrap_tab_nav {
  width: 100%;
  height: 56px;
  position: relative;
}

.wrap_tab {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  background-color: #fff;
}

.wrap_tab {
  box-shadow: 0 1px 0 #f4f4f4;
  ;
  transform: translateY(0);
  transition: all 0.2s linear;
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -ms-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  box-sizing: border-box;
}
.wrap_tab.fixed {
  position: fixed;
  z-index: 98;
}
.tab_nav.clearfix {
  overflow-x: auto;
  overflow-y: hidden;
  position: relative;
  height: 58px;
  margin-bottom: -1px;
}

.tab_nav.clearfix::-webkit-scrollbar {
  display: none !important;
  width: 0px;
  height: 0px;
}

.tab_nav.clearfix ul {
  position: absolute;
  left: 0px;
  top: 0;
  height: 58px;
  padding-left: 0px;
  padding-right: 0px;
  box-sizing: border-box;
  display: block;
  white-space: nowrap;
}

.tab_nav li {
  list-style: none;
  float: none;
  display: inline-block;
  margin-right: 32px;
  position: relative;
  cursor: pointer;
  height: 100%;
  line-break: 58px;
}

.tab_nav li a {
  display: inline-block;
  height: 55px;
  line-height: 55px;
  padding: 0;
  font-size: 16px;
  text-decoration: none;
}
.tab_nav li a:hover{
  color: #274a7d;
  border-bottom: 3px solid #274a7d;
}
.tab_nav li a:active{
  color: #274a7d;
  border-bottom: 3px solid #274a7d;
}

.tab_con {
  width: 100%;
  margin: 0 auto;
  width: 100%;
  font-size: 16px;
  line-height: 32px;
  color: rgba(0, 0, 0, .8);
}
::v-deep font{
	line-height: 40px;
}
::v-deep .tab_con{
  p{
    img{
      width: 100% !important;
      min-width: 100% !important;
    }
  }
}
.tab_con_bg {
  position: relative;
  top: 0;
}

.tab_con h3 {
  font-size: 32px;
  line-height: 45px;
  color: rgba(0, 0, 0, 0.85);
  text-align: center;
  font-weight: bold;
  margin-bottom: 40px;
}

.introduce {
  height: 116px;
  overflow: hidden;
}

.introduce p {
  margin-bottom: 16px;
}

.introduce_subtitle{
  color: rgba(0,0,0,.8);
}

.tab_con_introduce {
  width: 100%;
}

.introduce.expanded {
  height: auto;
}

.tab_con_introduce .expand {
  width: 150px;
  margin: 0 auto;
  text-align: center;
  cursor: pointer;
  z-index: 1;
  margin-top: 16px;
  color: rgba(0, 0, 0, .6);
  margin-top: 16px;
}
/* 鍔犲叆鎴戜滑*/
.anchor_join {
  position: relative;
  width: 100%;
  height: 100%;
}

.join_about {
  margin-top: 32px;
  color: rgba(0, 0, 0, .6);
}

.join_about span {
  display: block;
  text-align: center;
  font-weight: 400;
}

.join_cont {
  position: relative;
  margin-top: 44px;
  background: #ffffff;
}

.join_section {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  padding: 0 5%;
  text-align: center;
}

.join_line {
  width: 50%;
  margin: 24% auto;
  border-top: 1px solid rgba(0, 0, 0, .2);
}

.join_icon {
  float: left;
}

.detail_head {
  display: block;
  padding-bottom: 4px;
  font-weight: 500;
}

.detail_foot {
  display: block;
  font-weight: 400;
  color: #147BD1;
  cursor: pointer;
}

.detail_foot_col{
  margin-left: 9px;
}

.detail_foot:hover {
  color: #0058A7;
}

.detail_foot img {
  margin-bottom: 3px;
  margin-left: 2px;
}


.modal_wrap {
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all .3s;
  z-index: 100;
  background: #fff;
  overflow-y: auto;
}

.modal_head {
  text-align: right;
  padding: 60px;
}

.modal_close {
  display: inline-block;
  width: 18px;
  height: 18px;
  cursor: pointer;
//   background-image: url("../images/close-line.svg");
  background-size: cover;
  background-position: center;
}

.director_img {
  text-align: center;
  /* margin-right: 56px;
  width: 266px; */
}

.director_info {
  padding-left: 50px;
}

.info_name {
  font-size: 36px;
  /* color: #147BD1; */
  font-weight: 500;
  line-height: 50px;
  letter-spacing: 2px;
  color: rgba(0, 0, 0, .8);
  ;
}


.info_line {
  border-top: 1px solid rgba(0, 0, 0, .2);
  margin: 24px 0;
  width: 100%;
}

.info_detail {
  padding-bottom: 56px;
  text-align: justify;
  text-justify: inter-ideograph;
}

.info_detail p {
  margin-bottom: 16px;
}

.director_list>.director_img_list {
  margin-top: 68px;
  width: 228px;
  margin: 0 auto;
  /* border: 1px dashed; */
}

.director_list>.directordirector_img_list_photo:nth-child(3n+2) {
  margin: 0 88px;
  margin-top: 68px;
}

/* ------------------------------- */

ul,
li {
  list-style: none;
}

.tab_wrap {
  position: relative;
}

.tab_row {
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  height: 30px;
  position: absolute;
  bottom: 0;
  z-index: 1;
}

.tab_ul {
  position: absolute;
  left: 0px;
  top: 0;
  width: 100%;
  padding-left: 0px;
  padding-right: 0px;
  box-sizing: border-box;
  display: block;
  /* overflow: hidden; */
  white-space: nowrap;
  text-align: center;

}

.swiper-pagination-bullet {
  height: 15px;
  width: 15px;
  border-radius: 50%;
  background: #fff;
  opacity: .4;
}

.swiper-pagination-bullet-active {
  opacity: 1;
}

.swiper-pagination-bullet.active {
  background: #147BD1;
  transition: 0.1s;
}

.tabBox {
  position: relative
}

.tabList {
  width: 100%;
  float: left;
  color: #D3D3D3;
}

.tab_cont_year {
  padding-bottom: 40px;
}

.tab_cLine {
  display: inline-block;
  padding: 0 20px;
  background: #147BD1;
  position: relative;
  top: 40px;
  height: 36px;
}

.tab_cLine span {
  bottom: 30px;
  position: relative;
  font-size: 36px;
  color: #fff;
}

.tab_cont_info {
  /* padding: 24px; */
  color: #fff;
}
@media screen and (min-width: 320px) {
  .tab_nav li {
    margin-right: 30px !important;
  }
}
@media screen and (min-width: 360px) {
  .tab_nav li {
    margin-right: 36px !important;
  }
}
@media screen and (min-width: 375px) {
  .tab_nav li {
    margin-right: 40px !important;
  }
}

@media screen and (min-width: 768px) {
  .tab_nav li {
    margin-right: 56px !important;
  }
}


@media screen and (max-width: 1200px) {
	.con1 .con1_nei .con1_xun {
		width: 215px;
	}
}
@media screen and (max-width: 1040px) {
	.con1 .con1_nei .con1_xun {
		width: 31.3333%;
		margin: 85px 1% 45px 1%;
	}
	.con1 .con1_nei {
		width: 100%;
	}
}
@media screen and (max-width: 768px) {
	.con1 .con1_nei .con1_xun {
		width: 98%;
	}
}
</style>